@if (valueOne && valueTwo) {
    @if (valueTwo > valueOne) {
<svg-icon name="arrow-up"
          svgClass="arrow-up-icon"
          [class.green-arrow]="!inverted()"
          [class.red-arrow]="!!inverted()"
          [stretch]="true">
</svg-icon>
{{ formatNumber(valueTwo - valueOne) }} ({{
            calculatePercentage(valueOne, valueTwo)
}}%) relative to {{ genericTrendText() }}
    }
    @if (valueOne > valueTwo) {
<svg-icon name="arrow-down"
          svgClass="arrow-down-icon"
          [class.green-arrow]="!!inverted()"
          [class.red-arrow]="!inverted()"
          [stretch]="true">
</svg-icon>
{{ formatNumber(valueOne - valueTwo) }} ({{
            calculatePercentage(valueOne, valueTwo)
}}%) relative to {{ genericTrendText() }}
    }

    @if (valueOne === valueTwo) {
        no change relative to {{ genericTrendText() }}
    }
} @else {
    @if (result > 0) {
<svg-icon name="arrow-up"
          svgClass="arrow-up-icon"
          [class.green-arrow]="!inverted()"
          [class.red-arrow]="!!inverted()"
          [stretch]="true">
</svg-icon>
        up {{ formatPercent(result) }}% relative to the previous
{{ numericDayValue() === 1 ? "day" : numericDayValue() + "‑days" }}
    }

    @if (result < 0) {
<svg-icon name="arrow-down"
          svgClass="arrow-down-icon"
          [class.green-arrow]="!!inverted()"
          [class.red-arrow]="!inverted()"
          [stretch]="true">
</svg-icon>
        down {{ formatPercent(result) }}% relative to the previous
{{ numericDayValue() === 1 ? "day" : numericDayValue() + "‑days" }}
    }

    @if (result === 0) {
        no change relative to the previous
{{ numericDayValue() === 1 ? "day" : numericDayValue() + "‑days" }}
    }
}
